const pdfMake = require('pdfmake/build/pdfmake');
const pdfFonts = require('pdfmake/build/vfs_fonts');

pdfMake.vfs = pdfFonts?.default?.vfs || pdfFonts.vfs;

export const exportToPdf = (
  columns: any[],
  data: any[],
  title = 'Report'
) => {
  const visibleCols = columns.filter(
    (col) => col.displayType !== 'BUTTON' && col.displayType !== 'EXTERNAL_BUTTON'
  );

  const headers = visibleCols.map((col) => col.title);

  const body = data.map((row) =>
    visibleCols.map((col) => {
      const raw = row[col.dataIndex];
      if (col.displayType === 'CARD_SETS') {
        return convertCardSetsForPDF(raw);
      }
      if (col.displayType === 'SCAN_PERSONNEL') {
        return convertScanPersonnelForPDF(raw);
      }
      return typeof raw === 'string' || typeof raw === 'number'
        ? String(raw)
        : '';
    })
  );

  const docDefinition: any = {
    pageSize: 'A3', // Wider page for large column sets
    pageOrientation: 'landscape',
    content: [
      {
        text: title,
        style: 'header',
        alignment: 'center',
        margin: [0, 0, 0, 20],
      },
      {
        table: {
          headerRows: 1,
          // 👇 Smart column widths
          widths: headers.map(h => {
            const lower = h.toLowerCase();
            if (
              lower.includes('location') ||
              lower.includes('description') ||
              lower.includes('remarks') ||
              lower.includes('name')
            ) {
              return '*'; // flexible column
            }
            return 'auto'; // content-sized
          }),
          body: [headers, ...body],
        },
        layout: 'lightHorizontalLines',
      },
    ],
    styles: {
      header: {
        fontSize: 20,
        bold: true,
        color: '#1E293B',
      },
    },
    footer: (currentPage: number, pageCount: number) => ({
      columns: [
        {
          text: `Generated on ${new Date().toLocaleString()}`,
          alignment: 'left',
          fontSize: 9,
          margin: [40, 10, 0, 0],
        },
        {
          text: `Page ${currentPage} of ${pageCount}`,
          alignment: 'right',
          fontSize: 9,
          margin: [0, 10, 40, 0],
        },
      ],
    }),
  };

  pdfMake.createPdf(docDefinition).download(`${title}.pdf`);
};

// --- Helpers ---

const convertCardSetsForPDF = (data: string): string => {
  if (!data) return '';
  try {
    const json = JSON.parse(data);
    return json
      .map(
        (item: any) =>
          `${item.cardTypeName} ${item.cardColorName}${
            item.hasInnerBox ? ` (#ID: ${item.innerBoxStockId})` : ''
          }`
      )
      .join('\n');
  } catch {
    return '';
  }
};

const convertScanPersonnelForPDF = (data: string): string => {
  if (!data) return '';
  try {
    const json = JSON.parse(data);
    return json
      .map((item: any) => `${item.displayTitle}: ${item.scannedEmployeeId}`)
      .join('\n');
  } catch {
    return '';
  }
};
